import React, { useState, useEffect } from 'react';

import styles from './WorldCupHeader.module.css';
import { getWorldCupAssetUrl, WC_2026_TITLE, WC_2026_STATS } from '../../../server/services/custom-pages/constants';

const TABS = ["GROUP TABLES", "KNOCKOUT TREE", "SQUAD LIST", "FIXTURES", "GOLDEN BOOT"];

export default function WorldCupHeader({ activeTab, setActiveTab }) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    const scriptId = "stn-player-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://embed.sendtonews.com/player3/embedcode.js?fk=j1dzuhuw";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <>
      {/* Hero Background — absolute, behind content */}
      <div className={styles.heroSection}>
        <img
          src={getWorldCupAssetUrl('goldenDots.png')}
          alt=""
          className={styles.blob1}
          aria-hidden="true"
        />

        <div className={styles.overlayBottom} />
      </div>

      {/* Header content — positioned above hero background */}
      <div className={styles.headerContent}>

        {/* Title row */}
        <div className={styles.titleRow}>
          <div className={styles.titleTextGroup}>
            <h1 className={styles.mainTitle}>{WC_2026_TITLE}</h1>
            <div className={styles.divider} />
          </div>
          <img
            src={getWorldCupAssetUrl('cup.png')}
            alt="World Cup 2026 logo"
            className={styles.headerLogo}
          />
        </div>

        {/* Stats + Map row */}
        <div className={styles.statsMapRow}>
          <div className={styles.statsGroup}>
            {WC_2026_STATS.map((stat) => (
              <div className={styles.statTile} key={stat.label}>
                <span className={styles.statLabel}>{stat.label}</span>
                <span className={stat.isLong ? styles.statValueLong : styles.statValue}>
                  {stat.value}
                </span>
              </div>
            ))}
          </div>

          <div className={styles.mapCard}>
            {isMounted && (
              <>
                <div className={`voltax-mp-video-tag-player ${styles.wcVideoPlayer}`} data-stn-player="j1dzuhuw"></div>
                
              </>
            )}
          </div>
        </div>

      </div>
    </>
  );
}

export function WorldCupTabs({ activeTab, setActiveTab }) {
  return (
    <div className={styles.tabsNavBar}>
      {TABS.map((tab) => {
        const isActive = activeTab === tab;
        const isKnockout = tab === "KNOCKOUT TREE";
        return (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={
              isKnockout
                ? `${styles.knockoutTabButton} ${isActive ? styles.knockoutTabButtonActive : ''}`
                : `${styles.tabButton} ${isActive ? styles.tabButtonActive : ''}`
            }
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
}
